import { makeStyles } from '@material-ui/core/styles';

import { RiCheckLine, RiStopCircleLine } from '@remixicon/react';
import classNames from 'classnames';

import { ThinkingSpinner } from '../LoadingIndicator/ThinkingSpinner';
import { MarkdownContent } from '../MarkdownContent';
import {
  FADE_IN_ANIMATION,
  fadeInKeyframes,
  markdownColorInherit,
} from './styles';

const ICON_SIZE = 14;

const useStyles = makeStyles({
  ...fadeInKeyframes,
  root: {
    alignItems: 'flex-start',
    animation: FADE_IN_ANIMATION,
    display: 'flex',
    gap: 'var(--encore-spacing-tighter-2)',
  },
  icon: {
    flexShrink: 0,
    marginTop: '3px', // alignment correction
  },
  completedIcon: {
    color: 'var(--text-subdued)',
  },
  content: {
    color: 'var(--text-subdued)',
    minWidth: 0,
    ...markdownColorInherit,
  },
});

type ThinkingStepStatus = 'active' | 'completed' | 'interrupted';

type ThinkingStepProps = {
  children: string;
  status: ThinkingStepStatus;
};

const StatusIcon = ({
  status,
  iconClass,
  completedIconClass,
}: {
  status: ThinkingStepStatus;
  iconClass: string;
  completedIconClass: string;
}) => {
  if (status === 'active') {
    return <ThinkingSpinner size={ICON_SIZE} className={iconClass} />;
  }

  const Icon = status === 'interrupted' ? RiStopCircleLine : RiCheckLine;
  return (
    <Icon
      size={ICON_SIZE}
      className={classNames(iconClass, completedIconClass)}
    />
  );
};

export const ThinkingStep = ({ children, status }: ThinkingStepProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <StatusIcon
        status={status}
        iconClass={classes.icon}
        completedIconClass={classes.completedIcon}
      />
      <div className={classes.content}>
        <MarkdownContent>{children}</MarkdownContent>
      </div>
    </div>
  );
};
